<template>
  <helper-input-btn class="m-l-n-xs">
    <erp-input
        ref="input"
        @input="__set"
        slot="input"
        simple-border
        v-model="description"
        :placeholder="placeholder"
        :size="size"
        @keydown.enter="searchComitente"
        readonly
    >
      <u-popover v-if="this.findedData" hover :hover-delay="500" class="popover-user-profile" anchor="bottom middle"
                 self="top middle" :offset="[10, 10]">
        <div class="wrapper bg-white font-12">
          <div class="row">
            <div class="col m-r">ID: <strong>{{findedData.id}}</strong></div>
          </div>
          <div class="row m-t">
            <div class="col m-r">Nome: <strong>{{findedData.pessoa.name}}</strong></div>
          </div>
          <div class="row m-t">
            <div class="col m-r">Tipo: <strong>{{findedData.tipo ? findedData.tipo.nome : '-'}}</strong></div>
          </div>
          <div class="m-t">
            <e-btn label="Acessar comitente" />
          </div>
        </div>
      </u-popover>
    </erp-input>
    <div class="erp-icon-float" style="z-index: 10"><a @click="searchComitente"><i class="erp-icon search min"></i> </a></div>
    <img v-if="findedDataObj && findedDataObj.image && findedDataObj.image.thumb" :src="findedDataObj.image.thumb" style="height: 20px" />
<!--    <u-icon name="plus-circle" type="fa" icon-style="light" class="m-l-xs cursor-pointer" />-->
  </helper-input-btn>
</template>

<script>
import InputMixin from '../../../../reuse/input/mixin'
import {HelperInputBtn} from 'uloc-vue-plugin-erp'
import {UPopover} from 'uloc-vue'
import searchComitente from '../../../comitente/windows/search/SearchComitente'

export default {
  name: 'ComitenteInput',
  props: ['size'],
  mixins: [InputMixin],
  data () {
    return {
      findedData: this.findedDataObj
    }
  },
  watch: {
    findedData (v) {
      this.$emit('updateSelected', v)
    },
    findedDataObj (v) {
      this.adjust()
    }
  },
  mounted () {
    this.adjust()
  },
  components: {HelperInputBtn, UPopover},
  methods: {
    adjust () {
      if (this.findedDataObj) {
        this.description = this.findedDataObj.id + ' - ' + this.findedDataObj.pessoa.name
      }
    },
    __updateInternal () {
      this.updateInternal((v) => v.id + ' - ' + v.pessoa.name)
    },
    searchComitente: searchComitente
  }
}
</script>
